export default [
    {
      name: "Tazril Ali",
      img: "https://res.cloudinary.com/dio1saxjw/image/upload/w_1000,ar_1:1,c_fill,g_auto/v1621870401/core_members/tazril_bt88o8.jpg",
      role: "Frontend Developer",
      facebook: "https://www.facebook.com/tazrilparviz.ali",
      linkedin: "https://www.linkedin.com/in/tazril-ali-969987178/",
      github: "https://github.com/Tazril",
      portfolio: "https://tazril.github.io/",
    },
    {
      name: "Prateek Divyanshu",
      img: "https://res.cloudinary.com/dio1saxjw/image/upload/w_1000,ar_1:1,c_fill,g_auto/v1621870401/core_members/Prateek_Divyanshu_wmwgcw.jpg",
      role: "Backend Developer",
      facebook: "https://www.facebook.com/prateek.divyanshu",
      linkedin: "https://www.linkedin.com/in/prateek-divyanshu-476288124/",
      github: "https://github.com/Divyanshu-Prateek",
    },
    {
      name: "Mayank Roy",
      img: "https://res.cloudinary.com/dio1saxjw/image/upload/w_1000,ar_1:1,c_fill,g_auto/v1621870401/core_members/mayank_ggxzl2.jpg",
      role: "Content Creator",
      facebook: "https://www.facebook.com/mayankliv/",
      linkedin: "https://www.linkedin.com/in/mayankroy8/",
      github: "https://github.com/mayank-liv",
    },
    {
      name: "Suyog jadhav",
      img: "https://avatars.githubusercontent.com/u/30121918?v=4",
      role: "Product Analyst",
      facebook: "https://fb.com/IAmSuyogJadhav",
      linkedin: "https://linkedin.com/in/IAmSuyogJadhav",
      github: "https://github.com/IAmSuyogJadhav",
      portfolio: "https://www.suyogjadhav.com/",
    },
  ];